// FILECONTENT_START src/common/components/Form/FieldsContainer.tsx
import { Grid, GridProps } from "@mui/material";
import { ReactNode } from "react";

export interface FieldsContainerProps extends GridProps {
  children: ReactNode;
}

export default function FieldsContainer({
  children,
  ...props
}: FieldsContainerProps) {
  return (
    <Grid container spacing={2} {...props}>
      {children}
    </Grid>
  );
}

// FILECONTENT_END src/common/components/Form/FieldsContainer.tsx
